import commonGetters from '@/store/ui/common/getters'

const getters = {}

export default { ...commonGetters, ...getters }
